import {
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  DirectionalHint,
  SelectionMode,
  Text,
} from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import { Goleadores } from '../../system/SystemClient';
import ClubImageCircle from '../Common/ClubImageCircle';
import JugadorImageCircle from '../Common/JugadorImageCircle';
const TorneoTabGoleadores = ({
  goleadores,
  highlightClubId,
}: {
  goleadores: Goleadores[];
  highlightClubId?: string;
}) => {
  const getCols = (compact?: boolean) => {
    const columnsDesktop = [
      {
        key: 'posicion',
        name: compact ? '#' : 'Ranking',
        fieldName: 'posicion',
        minWidth: compact ? 10 : 70,
        maxWidth: compact ? 10 : 70,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return <span style={{ fontSize: compact ? 13 : 20 }}>{item.posicion}</span>;
        },
      },
      // {
      //   key: 'JugadorFoto',
      //   name: compact ? '' : 'Jugador',
      //   fieldName: 'JugadorFoto',
      //   minWidth: compact ? 20 : 80,
      //   maxWidth: compact ? 20 : 80,
      //   isResizable: true,
      //   onRender: (item: Goleadores) => {
      //     return (
      //       <div>
      //         <JugadorImageCircle
      //           escudo={item.jug_foto}
      //           width={compact ? 20 : 25}
      //           height={compact ? 20 : 25}
      //         ></JugadorImageCircle>
      //       </div>
      //     );
      //   },
      // },
      {
        key: 'Jugador',
        name: compact ? 'Jugador' : '',
        fieldName: 'Jugador',
        minWidth: compact ? 180 : 350,
        maxWidth: compact ? 180 : 350,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return (
            <span style={{ fontSize: compact ? 13 : 16, marginTop: 3, fontWeight: compact ? 500 : 400 }}>
              {item.jug_apellido}, {item.jug_nombre}
            </span>
          );
        },
      },

      {
        key: 'club_nombre',
        name: 'Club',
        fieldName: 'club_nombre',
        minWidth: compact ? 30 : 300,
        maxWidth: compact ? 30 : 300,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return (
            <div>
              <div style={{ display: 'inline-block' }}>
                <ClubImageCircle
                  escudo={item.club_escudo}
                  width={compact ? 20 : 25}
                  height={compact ? 20 : 25}
                ></ClubImageCircle>
              </div>
              {!compact && (
                <span
                  style={{
                    fontSize: 16,
                    marginTop: 0,
                    display: 'inline-block',
                    position: 'relative',
                    bottom: 10,
                    left: 10,
                    fontWeight: !!highlightClubId && highlightClubId === item.club_id ? 500 : 400,
                    color: '#605e5c',
                  }}
                >
                  {item.club_nombre}
                </span>
              )}
            </div>
          );
        },
      },

      {
        key: 'goles',
        name: 'Goles',
        fieldName: 'goles',
        minWidth: compact ? 40 : 80,
        maxWidth: compact ? 40 : 80,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return <span style={{ fontSize: compact ? 13 : 16, marginTop: 3 }}>{item.goles}</span>;
        },
      },
      {
        key: 'partidos',
        name: 'Partidos',
        fieldName: 'partidos',
        minWidth: compact ? 40 : 80,
        maxWidth: compact ? 40 : 80,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return <span style={{ fontSize: compact ? 13 : 16, marginTop: 3 }}>{item.partidos}</span>;
        },
      },

      {
        key: 'promedio',
        name: 'Promedio',
        fieldName: 'promedio',
        minWidth: compact ? 45 : 80,
        maxWidth: compact ? 45 : 80,
        isResizable: true,
        onRender: (item: Goleadores) => {
          return <span style={{ fontSize: compact ? 13 : 16, marginTop: 3 }}>{item.promedio}</span>;
        },
      },
    ];

    return columnsDesktop;
  };

  return (
    <>
      <div className="ms-Grid-row ">
        {goleadores.length > 0 ? (
          <>
            {/* =====================================================================
                              VISTA DESKTOP
        =====================================================================*/}
            <div id="viewDesktop" className="ms-hiddenSm">
              <div className="ms-Grid-col ms-sm12 ">
                <DetailsList
                  onShouldVirtualize={() => false}
                  items={goleadores.filter((g) =>
                    highlightClubId ? !!highlightClubId && highlightClubId === g.club_id : true
                  )}
                  columns={getCols()}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  onRenderRow={(props) => <OnRenderRowGoleador propsRow={props} />}
                />
              </div>
            </div>
            {/* =====================================================================
                              VISTA MOBILE
        =====================================================================*/}

            <div id="viewMobile" className="ms-hiddenMdUp">
              <div className="ms-Grid-col ms-sm12 ">
                <DetailsList
                  onShouldVirtualize={() => false}
                  items={goleadores.filter((g) =>
                    highlightClubId ? !!highlightClubId && highlightClubId === g.club_id : true
                  )}
                  columns={getCols(true)}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                  compact
                  onRenderRow={(props) => <OnRenderRowGoleador propsRow={props} />}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="ms-Grid-col ms-sm12 mt-2">
            <Text variant="medium">Todavía no hay goleadores para este torneo.</Text>
          </div>
        )}
      </div>
    </>
  );
};

const OnRenderRowGoleador = (props: any) => {
  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
  const buttonId = useId('callout-button');

  return (
    <div onClick={() => toggleIsCalloutVisible()}>
      <DetailsRow {...props.propsRow} id={buttonId} />
      {isCalloutVisible && (
        <Callout
          style={{ padding: 10, textAlign:'center' }}
          directionalHint={DirectionalHint.bottomLeftEdge}
          target={`#${buttonId}`}
          onDismiss={toggleIsCalloutVisible}
          role="alert"
        >
          <div style={{ display: 'inline-block' }}>
            <JugadorImageCircle
              escudo={props.propsRow.item.jug_foto}
              width={85}
              height={85}
            ></JugadorImageCircle>{' '}
          </div>
          <div style={{ display: 'contents', marginLeft: 10, position: 'relative', bottom: 5 }}>

            <Text variant="small" block>
              <span style={{ fontWeight: 700 }}> {props.propsRow.item.posicion} - {props.propsRow.item.jug_apellido},{' '}
                {props.propsRow.item.jug_nombre}</span>
            </Text>
            <Text variant="small" block>
              <span style={{ fontWeight: 500, color:'darkgray' }}> {props.propsRow.item.club_nombre} </span>
            </Text>
            <Text variant="small" block>
              <br></br>
            </Text>

            <table style={{fontSize: 13, width: '100%'}} >
              <tr>
                <td >Goles</td>
                <td style={{ fontWeight: 600 }}>{props.propsRow.item.goles}</td>
              </tr>
              <tr>
                <td>Partidos</td>
                <td style={{ fontWeight: 600 }}>{props.propsRow.item.partidos}</td>
              </tr>
              <tr>
                <td>Promedio</td>
                <td style={{ fontWeight: 600 }}>{props.propsRow.item.promedio}</td>
              </tr>
            </table>
          </div>
        </Callout>
      )}
    </div>
  );
};

export default TorneoTabGoleadores;
